import { makeStyles, createTheme } from '@material-ui/core/styles';
import { getDrawerStyle } from './drawerStyles'
import { appBarStyle } from './appBarStyles'
import { getManagmentStyle } from './managementStyle'
import { getGeneralStyle } from './ganaralStyle'
import { getNotificationStyle } from './notificationsStyles';
import { getDashboardStyle } from './dashboardStyles';
import { getSmsStyle } from './smsStyles';
import { getSiteTrackingStyle } from './siteTrackingStyles';
import { getCampaignEditorStyle } from './campaignEditorStyles';
import { getGroupStyle } from './groupStyle'
import { getWhatsappStyle } from './whatsappStyles';
import { dynamicProductCatalog } from './dynamicProductCatalog';
import { surveyStyle } from './surveyStyles';
import { BeeAiStyles } from './BeeAiStyles';
import { getPopupTriggersStyle } from './popupTriggers';
import { getPopUpManagementStyle } from './popUpManagementStyle';
import { getAnimationStyle } from './animationStyles';
import { sideMenuStyle } from './sideMenuStyle'

// App calls useClasses() during its own render. Before dark mode there was no
// MuiThemeProvider above App, so makeStyles built these classes from MUI's default theme:
// default breakpoints (lg 1280, not theme.js's 1367), default primary, and direction 'ltr',
// so jss-rtl never flipped them — every factory handles RTL itself through isRTL.
// The provider now sits in AppContainer, above App, so rebuild that same default theme and
// carry over only what dark mode adds (palette.type, custom), with flipping kept off.
const muiDefaultTheme = createTheme();
const toFactoryTheme = (appTheme) => ({
  ...muiDefaultTheme,
  palette: { ...muiDefaultTheme.palette, type: appTheme.palette.type },
  custom: appTheme.custom,
});

export const useClasses = (windowSize, isRTL = false, IsPoland = false) => makeStyles(appTheme => {
  const theme = toFactoryTheme(appTheme);
  return {
    ...getDrawerStyle(windowSize, isRTL, theme),
    ...appBarStyle(windowSize, isRTL, theme),
    ...getManagmentStyle(windowSize, isRTL, theme, IsPoland),
    ...getGeneralStyle(windowSize, isRTL, theme),
    ...getNotificationStyle(windowSize, isRTL, theme),
    ...getDashboardStyle(windowSize, isRTL, theme),
    ...getSmsStyle(windowSize, isRTL, theme),
    ...getSiteTrackingStyle(windowSize, isRTL),
    ...getCampaignEditorStyle(windowSize, isRTL),
    ...getGroupStyle(windowSize, isRTL, theme),
    ...getWhatsappStyle(windowSize, isRTL, theme),
    ...dynamicProductCatalog(isRTL),
    ...surveyStyle(windowSize, isRTL, theme),
    ...BeeAiStyles(windowSize, isRTL, theme),
    ...getPopupTriggersStyle(windowSize, isRTL, theme),
    ...getPopUpManagementStyle(windowSize, isRTL, theme),
    ...getAnimationStyle(windowSize, isRTL, theme),
    ...sideMenuStyle(windowSize, isRTL, theme)
  };
}, { flip: false })
